// export default defineI18nLocale(async (locale) => {
//   // const runtimeConfig = useRuntimeConfig();
//   // const api = runtimeConfig.public.admin_base + '/poeditor/en' || 'https://admin.www.ngprague.cz/poeditor/en';

//   // return await $fetch(api);
//   return $fetch('https://admin.www.ngprague.cz/poeditor/en');
// });

export default defineI18nLocale(async (locale) => {
  const runtimeConfig = useRuntimeConfig();
  const api = runtimeConfig.public.admin_base + '/poeditor/en' || 'https://admin.www.ngprague.cz/poeditor/en';

  const headers = {
    'Content-Language': 'en', // Zde můžeš dynamicky použít aktuální jazyk
  };

  try {
    return await $fetch(api, {
      headers, // Přidání hlaviček do požadavku
    });
  } catch (error) {
    console.error('Failed to fetch translations:', error);
    return {}; // Návrat prázdného objektu v případě chyby
  }
});
